<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users"></i> Cadastro de Lista</h3>
        <small>Cadastro de lista (segmentação) de contatos para envio via e-mail, whatsapp, etc.</small>
      </div>
    </div>
    <CampaignListAdd v-if="showAdd" ref="CampaignListAdd" v-on:Back="onBack" />
    <CampaignListGrid v-else ref="CampaignListGrid" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import CampaignListAdd from './components/add/campaignlistadd.vue'
import CampaignListGrid from './components/list/list.vue'

export default {
  name: 'CampaignList',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    CampaignListAdd,
    CampaignListGrid
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.CampaignListAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/campaignlist.vue